import { Routes, RouterModule } from "@angular/router";
import { BooksDistributedBarcodeComponent } from "./books-distributed-barcode/books-distributed-barcode.component";
import { BookInventoryBarcodeComponent } from "./book-inventory-barcode/book-inventory-barcode.component";
import { BookInventoryComponent } from "./book-inventory/book-inventory.component";
import { BooksDistributedComponent } from "./books-distributed/books-distributed.component";
import { BooksForInstructorComponent } from "./books-for-instructor/books-for-instructor.component";
import { DistrictAttendanceSummaryComponent } from "./district-attendance-summary/district-attendance-summary.component";
import { DistrictCAASSUsageComponent } from "./district-caassusage/district-caassusage.component";
import { DistrictDisciplineActionTierCountsComponent } from "./district-discipline-action-tier-counts/district-discipline-action-tier-counts.component";
import { DistrictManifestationReferralsInComplianceComponent } from "./district-manifestation-referrals-in-compliance/district-manifestation-referrals-in-compliance.component";
import { DistrictMonthlyReferralAveragesComponent } from "./district-monthly-referral-averages/district-monthly-referral-averages.component";
import { DistrictMTAStudentRideTimesComponent } from "./district-mtastudent-ride-times/district-mtastudent-ride-times.component";
import { DistrictOneCardExpressDailyBillingComponent } from "./district-one-card-express-daily-billing/district-one-card-express-daily-billing.component";
import { DistrictOneCardExpressQueueComponent } from "./district-one-card-express-queue/district-one-card-express-queue.component";
import { DistrictOneCardExpressShippingOrderComponent } from "./district-one-card-express-shipping-order/district-one-card-express-shipping-order.component";
import { DistrictRatioIntoOutofSchoolSuspensionsComponent } from "./district-ratio-into-outof-school-suspensions/district-ratio-into-outof-school-suspensions.component";
import { DistrictReferralsByCohortComponent } from "./district-referrals-by-cohort/district-referrals-by-cohort.component";
import { DistrictReferralsByEthnicityComponent } from "./district-referrals-by-ethnicity/district-referrals-by-ethnicity.component";
import { DistrictReferralsByHarassmentComponent } from "./district-referrals-by-harassment/district-referrals-by-harassment.component";
import { DistrictReferralsByIncidentTimeComponent } from "./district-referrals-by-incident-time/district-referrals-by-incident-time.component";
import { DistrictReferralsByInfractionLevelComponent } from "./district-referrals-by-infraction-level/district-referrals-by-infraction-level.component";
import { DistrictReferralsByInfractionComponent } from "./district-referrals-by-infraction/district-referrals-by-infraction.component";
import { DistrictReferralsByLocationComponent } from "./district-referrals-by-location/district-referrals-by-location.component";
import { DistrictReferralsPerYearPer100StudentsComponent } from "./district-referrals-per-year-per100-students/district-referrals-per-year-per100-students.component";
import { DistrictScanStationTrackingComponent } from "./district-scan-station-tracking/district-scan-station-tracking.component";
import { DistrictSchoolTotalsComponent } from "./district-school-totals/district-school-totals.component";
import { DistrictSuspensionStepsOutOfComplianceComponent } from "./district-suspension-steps-out-of-compliance/district-suspension-steps-out-of-compliance.component";
import { DistrictSuspensionWorkflowDetailComponent } from "./district-suspension-workflow-detail/district-suspension-workflow-detail.component";
import { DistrictSuspensionsNotAssignedMaximumDaysComponent } from "./district-suspensions-not-assigned-maximum-days/district-suspensions-not-assigned-maximum-days.component";
import { MTADistrictStatisticsChartComponent } from "./mtadistrict-statistics-chart/mtadistrict-statistics-chart.component";
import { PickListByHomeRoomComponent } from "./pick-list-by-home-room/pick-list-by-home-room.component";
import { ReportMaintenanceComponent } from "./report-maintenance/report-maintenance.component";
import { ReportUsageComponent } from "./report-usage/report-usage.component";
import { SchoolMessengerAttendanceComponent } from "./school-messenger-attendance/school-messenger-attendance.component";
import { CustomDetention1Component } from "./custom-detention1/custom-detention1.component";
import { IndividualStudentPBISComponent } from "./individual-student-pbis/individual-student-pbis.component";
import { InstructorPBISComponent } from "./instructor-pbis/instructor-pbis.component";
import { PBISHistoryComponent } from "./pbis-history/pbis-history.component";
import { ActiveBarcodesScannableComponent } from "./active-barcodes-scannable/active-barcodes-scannable.component";
import { VisitorBlockListComponent } from "./visitor-block-list/visitor-block-list.component";
import { TransitRiderDataComponent } from "./transit-rider-data/transit-rider-data.component";
import { ActiveBarcodesComponent } from "./activebarcodes/activebarcodes.component";
import { AdvisoryHRAttendanceComponent } from "./advisoryhrattendance/advisoryhrattendance.component";
import { AlphaStaffComponent } from "./alphastaff/alphastaff.component";
import { AlphaStudentDetailsComponent } from "./alphastudentdetails/alphastudentdetails.component";
import { AlphaStudentListComponent } from "./alphastudentlist/alphastudentlist.component";
import { AttendancebyDayComponent } from "./attendancebyday/attendancebyday.component";
import { AttendanceByTypeComponent } from "./attendancebytype/attendancebytype.component";
import { AttendanceSummaryComponent } from "./attendancesummary/attendancesummary.component";
import { AttendanceWithGroupingComponent } from "./attendancewithgrouping/attendancewithgrouping.component";
import { CardStatusComponent } from "./cardstatus/cardstatus.component";
import { CardUsageDuringSchoolAbsenceComponent } from "./cardusageduringschoolabsence/cardusageduringschoolabsence.component";
import { ClassAttendanceSummaryComponent } from "./classattendancesummary/classattendancesummary.component";
import { ClassAttendanceTrackingComponent } from "./classattendancetracking/classattendancetracking.component";
import { ClassAttendanceTrackingDetailsComponent } from "./classattendancetrackingdetails/classattendancetrackingdetails.component";
import { ClassRosterComponent } from "./classroster/classroster.component";
import { ConvertedIncidentsComponent } from "./convertedincidents/convertedincidents.component";
import { CutsAbsenceTardyComponent } from "./cutsabsencetardy/cutsabsencetardy.component";
import { DailyBulletinComponent } from "./dailybulletin/dailybulletin.component";
import { DailyHotListComponent } from "./dailyhotlist/dailyhotlist.component";
import { DailyMealCodesComponent } from "./dailymealcodes/dailymealcodes.component";
import { DetentionBalanceComponent } from "./detentionbalance/detentionbalance.component";
import { DetentionOwedComponent } from "./detentionowed/detentionowed.component";
import { DetentionSummaryComponent } from "./detentionsummary/detentionsummary.component";
import { EarlyReleaseComponent } from "./earlyrelease/earlyrelease.component";
import { EntryAlertComponent } from "./entryalert/entryalert.component";
import { EntryAlertbyContainerComponent } from "./entryalertbycontainer/entryalertbycontainer.component";
import { EntryAlertGroupedComponent } from "./entryalertgrouped/entryalertgrouped.component";
import { EntryAlertGroupedDetailsComponent } from "./entryalertgroupeddetails/entryalertgroupeddetails.component";
import { EntryStatusByTimeComponent } from "./entrystatusbytime/entrystatusbytime.component";
import { EntryTypeComponent } from "./entrytype/entrytype.component";
import { EntryTypeCountsComponent } from "./entrytypecounts/entrytypecounts.component";
import { ExceptionStationComponent } from "./exceptionstation/exceptionstation.component";
import { FinesOwedComponent } from "./finesowed/finesowed.component";
import { FinesOwedSummaryComponent } from "./finesowedsummary/finesowedsummary.component";
import { FinesPaidComponent } from "./finespaid/finespaid.component";
import { GroupActionComponent } from "./groupaction/groupaction.component";
import { GuardianCommunicationComponent } from "./guardiancommunication/guardiancommunication.component";
import { HallPassReportComponent } from "./hallpassreport/hallpassreport.component";
import { HomeroomAttendanceTotalsComponent } from "./homeroomattendancetotals/homeroomattendancetotals.component";
import { HotListedCardUsageComponent } from "./hotlistedcardusage/hotlistedcardusage.component";
import { IDCardsPrintedComponent } from "./idcardsprinted/idcardsprinted.component";
import { IncidentsbyCohortComponent } from "./incidentsbycohort/incidentsbycohort.component";
import { IncidentsbyEthnicityComponent } from "./incidentsbyethnicity/incidentsbyethnicity.component";
import { IncidentsbyIncidentTimeComponent } from "./incidentsbyincidenttime/incidentsbyincidenttime.component";
import { IncidentsbyInfractionComponent } from "./incidentsbyinfraction/incidentsbyinfraction.component";
import { IncidentsbyInfractionLevelComponent } from "./incidentsbyinfractionlevel/incidentsbyinfractionlevel.component";
import { IncidentsbyLocationComponent } from "./incidentsbylocation/incidentsbylocation.component";
import { IncidentsbyMonthInfractionLevelComponent } from "./incidentsbymonthinfractionlevel/incidentsbymonthinfractionlevel.component";
import { IncidentsbyStaffComponent } from "./incidentsbystaff/incidentsbystaff.component";
import { IncidentsbyStudentComponent } from "./incidentsbystudent/incidentsbystudent.component";
import { IncidentsperYearper100StudentsComponent } from "./incidentsperyearper100students/incidentsperyearper100students.component";
import { IncompleteStudentAddressComponent } from "./incompletestudentaddress/incompletestudentaddress.component";
import { IndividualStudentMeritComponent } from "./individualstudentmerit/individualstudentmerit.component";
import { InOutOfSchoolSuspensionsComponent } from "./inoutofschoolsuspensions/inoutofschoolsuspensions.component";
import { InstructorMeritsDemeritsComponent } from "./instructormeritsdemerits/instructormeritsdemerits.component";
import { InstructorMissingSectionComponent } from "./instructormissingsection/instructormissingsection.component";
import { LockersComponent } from "./lockers/lockers.component";
import { MarkRosterComponent } from "./markroster/markroster.component";
import { MealAccountBalanceComponent } from "./mealaccountbalance/mealaccountbalance.component";
import { MealAccountDepositComponent } from "./mealaccountdeposit/mealaccountdeposit.component";
import { MealsChargedBySubsidyComponent } from "./mealschargedbysubsidy/mealschargedbysubsidy.component";
import { MealTypeCountsComponent } from "./mealtypecounts/mealtypecounts.component";
import { MeritsDemeritsComponent } from "./meritsdemerits/meritsdemerits.component";
import { MTACardAbuseCountsComponent } from "./mtacardabusecounts/mtacardabusecounts.component";
import { NumberofCardsPrintedComponent } from "./numberofcardsprinted/numberofcardsprinted.component";
import { OptInBarcodeCardComponent } from "./optinbarcodecard/optinbarcodecard.component";
import { ParentGuardianOptInComponent } from "./parentguardianoptin/parentguardianoptin.component";
import { ParentGuardianOptInBarcodeComponent } from "./parentguardianoptinbarcode/parentguardianoptinbarcode.component";
import { PerfectAttendanceComponent } from "./perfectattendance/perfectattendance.component";
import { PeriodAttendanceCountsComponent } from "./periodattendancecounts/periodattendancecounts.component";
import { PhotoBookComponent } from "./photo-book/photobook.component";
import { PhotoLabelsComponent } from "./photolabels/photolabels.component";
import { PhotoLabels3ColumnsComponent } from "./photolabels3columns/photolabels3columns.component";
import { PhotosbyComponent } from "./photosby/photosby.component";
import { PrincipalSchoolStatisticsComponent } from "./principalschoolstatistics/principalschoolstatistics.component";
import { RidingBusDuringSchoolComponent } from "./ridingbusduringschool/ridingbusduringschool.component";
import { ScanEntryExitExceptionsComponent } from "./scanentryexitexceptions/scanentryexitexceptions.component";
import { ScanStationAttendancesComponent } from "./scanstationattendances/scanstationattendances.component";
import { ScanStationsSummaryComponent } from "./scanstationssummary/scanstationssummary.component";
import { StaffInOutScanComponent } from "./staffinoutscan/staffinoutscan.component";
import { StaffPhotos3ColumnsComponent } from "./staffphotos3columns/staffphotos3columns.component";
import { StaffPhotos4ColumnsComponent } from "./staffphotos4columns/staffphotos4columns.component";
import { StudentAbsentTardyExcuseComponent } from "./studentabsenttardyexcuse/studentabsenttardyexcuse.component";
import { StudentAttendanceHistoryComponent } from "./studentattendancehistory/studentattendancehistory.component";
import { StudentAttendanceStatusComponent } from "./studentattendancestatus/studentattendancestatus.component";
import { StudentCaassTransactionsComponent } from "./studentcaasstransactions/studentcaasstransactions.component";
import { StudentCardStatusComponent } from "./studentcardstatus/studentcardstatus.component";
import { StudentClassAttendanceComponent } from "./studentclassattendance/studentclassattendance.component";
import { StudentClassAttendanceReconciliationComponent } from "./studentclassattendancereconciliation/studentclassattendancereconciliation.component";
import { StudentCutsbyNumberComponent } from "./studentcutsbynumber/studentcutsbynumber.component";
import { StudentCutsMTDYTDComponent } from "./studentcutsmtdytd/studentcutsmtdytd.component";
import { StudentCutsMTDYTDDetailComponent } from "./studentcutsmtdytddetail/studentcutsmtdytddetail.component";
import { StudentIDCardHistoryComponent } from "./studentidcardhistory/studentidcardhistory.component";
import { StudentMealSubsidyTypesComponent } from "./studentmealsubsidytypes/studentmealsubsidytypes.component";
import { StudentsByInfractionComponent } from "./studentsbyinfraction/studentsbyinfraction.component";
import { StudentScheduleLabelsComponent } from "./studentschedulelabels/studentschedulelabels.component";
import { StudentsonSuspensionComponent } from "./studentsonsuspension/studentsonsuspension.component";
import { StudentsSuspendedHistoryComponent } from "./studentssuspendedhistory/studentssuspendedhistory.component";
import { StudentStatusForTheDayComponent } from "./studentstatusfortheday/studentstatusfortheday.component";
import { StudentsWithMissingAlertsComponent } from "./studentswithmissingalerts/studentswithmissingalerts.component";
import { StudentTardiesWithTimesComponent } from "./studenttardieswithtimes/studenttardieswithtimes.component";
import { StudentWithAlertComponent } from "./studentwithalert/studentwithalert.component";
import { StudentWithoutPhotosComponent } from "./studentwithoutphotos/studentwithoutphotos.component";
import { SuspensionsNotAssignedMaximumDaysComponent } from "./suspensionsnotassignedmaximumdays/suspensionsnotassignedmaximumdays.component";
import { SuspensionWorkflowDetailComponent } from "./suspensionworkflowdetail/suspensionworkflowdetail.component";
import { TeacherAttendanceVerificationComponent } from "./teacherattendanceverification/teacherattendanceverification.component";
import { TimeStampScanningComponent } from "./timestampscanning/timestampscanning.component";
import { VisitorlogsbydateComponent } from "./visitorlogsbydate/visitorlogsbydate.component";
import { VisitorLogsbyPassTemplateComponent } from "./visitorlogsbypasstemplate/visitorlogsbypasstemplate.component";
import { VisitorLogsbyVisitorComponent } from "./visitorlogsbyvisitor/visitorlogsbyvisitor.component";
import { VisitorsbyContainerComponent } from "./visitorsbycontainer/visitorsbycontainer.component";
import { VisitorsbyStatusComponent } from "./visitorsbystatus/visitorsbystatus.component";
import { VisitorsPhotos3ColsComponent } from "./visitorsphotos3cols/visitorsphotos3cols.component";
import { VisitorsPhotos4ColsComponent } from "./visitorsphotos4cols/visitorsphotos4cols.component";
import { VisitorsTodayComponent } from "./visitorstoday/visitorstoday.component";
import { VisitorSummaryComponent } from "./visitorsummary/visitorsummary.component";
import { WeeklyHomeroomSheetComponent } from "./weeklyhomeroomsheet/weeklyhomeroomsheet.component";
import { MsVisitorsComponent } from "./ms-visitors/ms-visitors.component";
import { MsVisitorLogComponent } from "./ms-visitor-log/ms-visitor-log.component";
import { MsBlockListComponent } from "./ms-block-list/ms-block-list.component";
import { MsFacilityTimeComponent } from "./ms-facility-time/ms-facility-time.component";
import { MsVisitorTimeInFacilitiesComponent } from "./ms-visitor-time-in-facilities/ms-visitor-time-in-facilities.component";
import { HsSchoolLogComponent } from "./hs-school-log/hs-school-log.component";
import { HsSchoolSummaryComponent } from "./hs-school-summary/hs-school-summary.component";
import { NotifyStudentRegComponent } from "./notify-student-reg/notify-student-reg.component";
import { NotifyStudentListParentsComponent } from "./notify-student-list-parents/notify-student-list-parents.component";
import { NotifyParentListStudentsComponent } from "./notify-parent-list-students/notify-parent-list-students.component";
import { ScanStationBadScanDataComponent } from "./scan-station-bad-scan-data/scan-station-bad-scan-data.component";
import { StudentQrCodesComponent } from "./student-qr-codes/student-qr-codes.component";
import { StaffBarcodeExportComponent } from "./staff-barcode-export/staff-barcode-export.component";
import { MsUsageComponent } from "./ms-usage/ms-usage.component";
import { StudentDigitalIDRegComponent } from "./student-digital-idreg/student-digital-idreg.component";
import { TimestampTimeInEventComponent } from "./timestamp-time-in-event/timestamp-time-in-event.component";
import { StudentOldPhotosComponent } from "./student-old-photos/student-old-photos.component";
import { DistrictCaassUsageSimpleComponent } from "./district-caass-usage-simple/district-caass-usage-simple.component";
import { DistrictCaassUsageFullComponent } from "./district-caass-usage-full/district-caass-usage-full.component";
import { TempIdCardsPrintedComponent } from "./temp-id-cards-printed/temp-id-cards-printed.component";
import { ParentPortalUsersByStudentComponent } from "./parent-portal-users-by-student/parent-portal-users-by-student.component";
import { StudentPortalUsersComponent } from "./student-portal-users/student-portal-users.component";
import { StaffPortalUsersComponent } from "./staff-portal-users/staff-portal-users.component";
import { ParentPortalAllUsersComponent } from "./parent-portal-all-users/parent-portal-all-users.component";
import { StudentWithdrawTransferComponent } from "./student-withdraw-transfer/student-withdraw-transfer.component";
import { CaassPassStudentTotalsComponent } from "./caass-pass-student-totals/caass-pass-student-totals.component";
import { AttendanceByLocationComponent } from "./attendance-by-location/attendance-by-location.component";
import { BusRunningLateComponent } from "./bus-running-late/bus-running-late.component";
import { InactiveCardsScannedComponent } from "./inactive-cards-scanned/inactive-cards-scanned.component";
import { PublicTransitRiderStatusComponent } from "./public-transit-rider-status/public-transit-rider-status.component";
import { BlockListScansComponent } from "./block-list-scans/block-list-scans.component";
import { AccessScanningComponent } from "./access-scanning/access-scanning.component";
import { ExitScanningComponent } from "./exit-scanning/exit-scanning.component";
import { EventScanningComponent } from "./event-scanning/event-scanning.component";
import { TimestampScanningBySchoolComponent } from "./timestamp-scanning-by-school/timestamp-scanning-by-school.component";
import { AttendanceWithExcuseComponent } from "./attendance-with-excuse/attendance-with-excuse.component";
import { AlreadyScannedInComponent } from "./already-scanned-in/already-scanned-in.component";
import { StudentsNotRidingComponent } from "./students-not-riding/students-not-riding.component";
import { StudentsNeverOnBusComponent } from "./students-never-on-bus/students-never-on-bus.component";
import { TimescanScannedIntoEventComponent } from "./timescan-scanned-into-event/timescan-scanned-into-event.component";

export const ReportRoutes: Routes = [
	{ path: "", redirectTo: "/Report/advisoryhrattendance", pathMatch: "full" },
	{
		path: "advisoryhrattendance",
		data: { title: "Advisory HR Attendance" },
		component: AdvisoryHRAttendanceComponent,
	},
	{
		path: "attendancebytype",
		data: { title: "Attendance By Type" },
		component: AttendanceByTypeComponent,
	},
	{
		path: "attendancewithgrouping",
		data: { title: "Attendance With Grouping" },
		component: AttendanceWithGroupingComponent,
	},
	{
		path: "entryalert",
		data: { title: "Entry Alert" },
		component: EntryAlertComponent,
	},
	{
		path: "classroster",
		data: { title: "Class Roster" },
		component: ClassRosterComponent,
	},
	{
		path: "dailymealcodes",
		data: { title: "Daily Meal Codes" },
		component: DailyMealCodesComponent,
	},
	{
		path: "entrystatusbytime",
		data: { title: "Entry Status By Time" },
		component: EntryStatusByTimeComponent,
	},
	{
		path: "mealschargedbysubsidy",
		data: { title: "Meals charged By Subsidy" },
		component: MealsChargedBySubsidyComponent,
	},
	{
		path: "perfectattendance",
		data: { title: "Perfect Attendance" },
		component: PerfectAttendanceComponent,
	},
	{
		path: "entrytype",
		data: { title: "Entry Type" },
		component: EntryTypeComponent,
	},
	{
		path: "studentwithoutphotos",
		data: { title: "Student Without Photos" },
		component: StudentWithoutPhotosComponent,
	},
	{
		path: "studenttardieswithtimes",
		data: { title: "Student Tardies w/Times" },
		component: StudentTardiesWithTimesComponent,
	},
	{
		path: "timestampscanning",
		data: { title: "Time Stamp Scanning" },
		component: TimeStampScanningComponent,
	},
	{
		path: "studentstatusfortheday",
		data: { title: "Student Status For The Day" },
		component: StudentStatusForTheDayComponent,
	},
	{
		path: "studentabsenttardyexcuse",
		data: { title: "Student Absent Tardy Excuse" },
		component: StudentAbsentTardyExcuseComponent,
	},
	{
		path: "photobook",
		data: { title: "Photo Book" },
		component: PhotoBookComponent,
	},

	{
		path: "attendancebytype",
		data: { title: "Attendance By Type" },
		component: AttendanceByTypeComponent,
	},
	{
		path: "classattendancetracking",
		data: { title: "Class Attendance Tracking" },
		component: ClassAttendanceTrackingComponent,
	},
	{
		path: "idcardsprinted",
		data: { title: "ID Cards Printed" },
		component: IDCardsPrintedComponent,
	},
	{
		path: "instructormissingsection",
		data: { title: "Instructor Missing Section" },
		component: InstructorMissingSectionComponent,
	},
	//{path:'scanstationattendance', data:{title:'Scan Station Attendance'},component:ScanStationAttendancesComponent},
	{
		path: "studentattendancehistory",
		data: { title: "Student Attendance History" },
		component: StudentAttendanceHistoryComponent,
	},
	{
		path: "studentattendancestatus",
		data: { title: "Student Attendance Status" },
		component: StudentAttendanceStatusComponent,
	},
	{
		path: "studentclassattendance",
		data: { title: "Student Class Attendance " },
		component: StudentClassAttendanceComponent,
	},
	{
		path: "studentclassattendancereconciliation",
		data: { title: "Student Class Attendance Reconciliation " },
		component: StudentClassAttendanceReconciliationComponent,
	},
	{
		path: "scanstationattendances",
		data: { title: "Scan Station Attendance " },
		component: ScanStationAttendancesComponent,
	},
	{
		path: "studentwithalert",
		data: { title: "Student with Alert" },
		component: StudentWithAlertComponent,
	},

	{
		path: "visitorlogsbydate",
		data: { title: "Visitor Logs By Date" },
		component: VisitorlogsbydateComponent,
	},
	{
		path: "convertedincidents",
		data: { title: "Converted Incidents" },
		component: ConvertedIncidentsComponent,
	},
	//{path:'detentionbalance', data:{title:'Detention Balance'},component:DetentionBalanceComponent},
	//{path:'detentionowed', data:{title:'Detention Owed'},component:DetentionOwedComponent},
	{
		path: "inoutofschoolsuspensions",
		data: { title: "In / Out of School Suspensions" },
		component: InOutOfSchoolSuspensionsComponent,
	},
	{
		path: "studentsbyinfraction",
		data: { title: "Students By Infraction" },
		component: StudentsByInfractionComponent,
	},
	{
		path: "studentswithmissingalerts",
		data: { title: "Students With Missing Alerts" },
		component: StudentsWithMissingAlertsComponent,
	},
	{
		path: "suspensionworkflowdetail",
		data: { title: "Suspension Workflow Detail" },
		component: SuspensionWorkflowDetailComponent,
	},
	//{path:'suspensionsnotassignedmaximum', data:{title:'Suspensions Not Assigned Maximum Days'},component:SuspensionsNotAssignedMaximumComponent},

	//Generated:
	{
		path: "alphastudentdetails",
		data: { title: "Alpha Student Details" },
		component: AlphaStudentDetailsComponent,
	},
	{
		path: "attendancebyday",
		data: { title: "Attendance By Day" },
		component: AttendancebyDayComponent,
	},
	{
		path: "attendancesummary",
		data: { title: "Attendance Summary" },
		component: AttendanceSummaryComponent,
	},
	{
		path: "cutsabsencetardy",
		data: { title: "Cuts Absence Tardy" },
		component: CutsAbsenceTardyComponent,
	},
	{
		path: "earlyrelease",
		data: { title: "Early Release" },
		component: EarlyReleaseComponent,
	},
	{
		path: "entrytype",
		data: { title: "Entry Type" },
		component: EntryTypeComponent,
	},
	{
		path: "exceptionstation",
		data: { title: "Exception Station" },
		component: ExceptionStationComponent,
	},
	{
		path: "scanstationssummary",
		data: { title: "ScanStations Summary" },
		component: ScanStationsSummaryComponent,
	},
	{
		path: "weeklyhomeroomsheet",
		data: { title: "Weekly Homeroom Sheet" },
		component: WeeklyHomeroomSheetComponent,
	},
	{
		path: "studentstatusfortheday",
		data: { title: "Student Status for the day" },
		component: StudentStatusForTheDayComponent,
	},
	{
		path: "studentcutsmtdytd",
		data: { title: "Student Cuts MTD YTD" },
		component: StudentCutsMTDYTDComponent,
	},
	{
		path: "studentcutsmtdytddetail",
		data: { title: "Student Cuts MTD YTD Detail" },
		component: StudentCutsMTDYTDDetailComponent,
	},
	{
		path: "studentsonsuspension",
		data: { title: "Students on Suspension" },
		component: StudentsonSuspensionComponent,
	},
	//    {path: 'studentswithoutphotos', data:{title:'Students Without Photos'},component:StudentsWithoutPhotosComponent},
	{
		path: "lockers",
		data: { title: "Lockers" },
		component: LockersComponent,
	},
	{
		path: "perfectattendance",
		data: { title: "Perfect Attendance" },
		component: PerfectAttendanceComponent,
	},
	{
		path: "studentcutsbynumber",
		data: { title: "Student Cuts by Number" },
		component: StudentCutsbyNumberComponent,
	},
	{
		path: "studentmealsubsidytypes",
		data: { title: "Student Meal Subsidy Types" },
		component: StudentMealSubsidyTypesComponent,
	},
	{
		path: "entryalert",
		data: { title: "Entry Alert" },
		component: EntryAlertComponent,
	},
	{
		path: "alphastaff",
		data: { title: "Alpha Staff" },
		component: AlphaStaffComponent,
	},
	{
		path: "studentidcardhistory",
		data: { title: "Student ID Card History" },
		component: StudentIDCardHistoryComponent,
	},
	{
		path: "alphastudentlist",
		data: { title: "Alpha Student List" },
		component: AlphaStudentListComponent,
	},
	{
		path: "entrytypecounts",
		data: { title: "Entry Type Counts" },
		component: EntryTypeCountsComponent,
	},
	{
		path: "homeroomattendancetotals",
		data: { title: "Homeroom Attendance Totals" },
		component: HomeroomAttendanceTotalsComponent,
	},
	{
		path: "numberofcardsprinted",
		data: { title: "Number of Cards Printed" },
		component: NumberofCardsPrintedComponent,
	},
	{
		path: "advisoryhrattendance",
		data: { title: "Advisory HR Attendance" },
		component: AdvisoryHRAttendanceComponent,
	},
	{
		path: "studentsbyinfraction",
		data: { title: "Students by Infraction" },
		component: StudentsByInfractionComponent,
	},
	{
		path: "finesowedsummary",
		data: { title: "Fines Owed Summary" },
		component: FinesOwedSummaryComponent,
	},
	{
		path: "activebarcodes",
		data: { title: "Active Barcodes" },
		component: ActiveBarcodesComponent,
	},
	{
		path: "activebarcodesscannable",
		data: { title: "Active Barcodes (Scannable)" },
		component: ActiveBarcodesScannableComponent,
	},
	{
		path: "dailymealcodes",
		data: { title: "Daily Meal Codes" },
		component: DailyMealCodesComponent,
	},
	{
		path: "idcardsprinted",
		data: { title: "ID Cards Printed" },
		component: IDCardsPrintedComponent,
	},
	{
		path: "entryalertgroupeddetails",
		data: { title: "Entry Alert Grouped Details" },
		component: EntryAlertGroupedDetailsComponent,
	},
	{
		path: "studentssuspendedhistory",
		data: { title: "Students Suspended History" },
		component: StudentsSuspendedHistoryComponent,
	},
	{
		path: "entrystatusbytime",
		data: { title: "Entry Status by Time" },
		component: EntryStatusByTimeComponent,
	},
	{
		path: "photosby",
		data: { title: "Photos by" },
		component: PhotosbyComponent,
	},
	{
		path: "photolabels",
		data: { title: "Photo Labels" },
		component: PhotoLabelsComponent,
	},
	{
		path: "teacherattendanceverification",
		data: { title: "Teacher Attendance Verification" },
		component: TeacherAttendanceVerificationComponent,
	},
	{
		path: "classattendancetracking",
		data: { title: "Class Attendance Tracking" },
		component: ClassAttendanceTrackingComponent,
	},
	{
		path: "dailybulletin",
		data: { title: "Daily Bulletin" },
		component: DailyBulletinComponent,
	},
	{
		path: "incompletestudentaddress",
		data: { title: "Incomplete Student Address" },
		component: IncompleteStudentAddressComponent,
	},
	{
		path: "finespaid",
		data: { title: "Fines Paid" },
		component: FinesPaidComponent,
	},
	{
		path: "studentschedulelabels",
		data: { title: "Student Schedule Labels" },
		component: StudentScheduleLabelsComponent,
	},
	{
		path: "finesowed",
		data: { title: "Fines Owed" },
		component: FinesOwedComponent,
	},
	{
		path: "staffphotos3columns",
		data: { title: "Staff Photos 3 Columns" },
		component: StaffPhotos3ColumnsComponent,
	},
	{
		path: "staffphotos4columns",
		data: { title: "Staff Photos 4 Columns" },
		component: StaffPhotos4ColumnsComponent,
	},
	{
		path: "studentclassattendance",
		data: { title: "Student Class Attendance" },
		component: StudentClassAttendanceComponent,
	},
	{
		path: "classroster",
		data: { title: "Class Roster" },
		component: ClassRosterComponent,
	},
	{
		path: "groupaction",
		data: { title: "Group Action" },
		component: GroupActionComponent,
	},
	{
		path: "classattendancesummary",
		data: { title: "Class Attendance Summary" },
		component: ClassAttendanceSummaryComponent,
	},
	{
		path: "timestampscanning",
		data: { title: "Timestamp Scanning" },
		component: TimeStampScanningComponent,
	},
	{
		path: "meritsdemerits",
		data: { title: "Merits Demerits" },
		component: MeritsDemeritsComponent,
	},
	{
		path: "mealschargedbysubsidy",
		data: { title: "Meals Charged by Subsidy" },
		component: MealsChargedBySubsidyComponent,
	},
	{
		path: "mealaccountbalance",
		data: { title: "Meal Account Balance" },
		component: MealAccountBalanceComponent,
	},
	{
		path: "entryalertgrouped",
		data: { title: "Entry Alert Grouped" },
		component: EntryAlertGroupedComponent,
	},
	{
		path: "classattendancetrackingdetails",
		data: { title: "Class Attendance Tracking Details" },
		component: ClassAttendanceTrackingDetailsComponent,
	},
	{
		path: "studentcardstatus",
		data: { title: "Student Card Status" },
		component: StudentCardStatusComponent,
	},
	{
		path: "scanentryexitexceptions",
		data: { title: "Scan Entry Exit Exceptions" },
		component: ScanEntryExitExceptionsComponent,
	},
	{
		path: "incidentsbyinfraction",
		data: { title: "Incidents by Infraction" },
		component: IncidentsbyInfractionComponent,
	},
	{
		path: "incidentsbylocation",
		data: { title: "Incidents by Location" },
		component: IncidentsbyLocationComponent,
	},
	{
		path: "incidentsbystudent",
		data: { title: "Incidents by Student" },
		component: IncidentsbyStudentComponent,
	},
	{
		path: "incidentsbyincidenttime",
		data: { title: "Incidents by Incident Time" },
		component: IncidentsbyIncidentTimeComponent,
	},
	{
		path: "incidentsbyinfractionlevel",
		data: { title: "Incidents by Infraction Level" },
		component: IncidentsbyInfractionLevelComponent,
	},
	{
		path: "incidentsbyethnicity",
		data: { title: "Incidents by Ethnicity" },
		component: IncidentsbyEthnicityComponent,
	},
	{
		path: "incidentsbycohort",
		data: { title: "Incidents by Cohort" },
		component: IncidentsbyCohortComponent,
	},
	{
		path: "suspensionsnotassignedmaximumdays",
		data: { title: "Suspensions Not Assigned Maximum Days" },
		component: SuspensionsNotAssignedMaximumDaysComponent,
	},
	{
		path: "suspensionworkflowdetail",
		data: { title: "Suspension Workflow Detail" },
		component: SuspensionWorkflowDetailComponent,
	},
	{
		path: "inout-ofschoolsuspensions",
		data: { title: "In  Out-of School Suspensions" },
		component: InOutOfSchoolSuspensionsComponent,
	},
	{
		path: "incidentsbymonthinfractionlevel",
		data: { title: "Incidents by Month Infraction Level" },
		component: IncidentsbyMonthInfractionLevelComponent,
	},
	{
		path: "incidentsperyearper100students",
		data: { title: "Incidents per Year per 100 Students" },
		component: IncidentsperYearper100StudentsComponent,
	},
	{
		path: "incidentsbystaff",
		data: { title: "Incidents by Staff" },
		component: IncidentsbyStaffComponent,
	},
	// {
	// 	path: "parentguardianoptin",
	// 	data: { title: "Parent  Guardian Opt In" },
	// 	component: ParentGuardianOptInComponent,
	// },
	// {
	// 	path: "optinbarcodecard",
	// 	data: { title: "Opt In Barcode Card" },
	// 	component: OptInBarcodeCardComponent,
	// },
	// {
	// 	path: "parentguardianoptinbarcode",
	// 	data: { title: "Parent  Guardian Opt In Barcode" },
	// 	component: ParentGuardianOptInBarcodeComponent,
	// },
	// {
	// 	path: "guardiancommunication",
	// 	data: { title: "Guardian Communication" },
	// 	component: GuardianCommunicationComponent,
	// },
	{
		path: "staffinoutscan",
		data: { title: "Staff In Out Scan" },
		component: StaffInOutScanComponent,
	},
	{
		path: "photolabels3columns",
		data: { title: "Photo Labels 3 Columns" },
		component: PhotoLabels3ColumnsComponent,
	},
	{
		path: "hallpassreport",
		data: { title: "Hall Pass Report" },
		component: HallPassReportComponent,
	},
	{
		path: "studentattendancehistory",
		data: { title: "Student Attendance History" },
		component: StudentAttendanceHistoryComponent,
	},
	{
		path: "instructormeritsdemerits",
		data: { title: "Instructor Merits Demerits" },
		component: InstructorMeritsDemeritsComponent,
	},
	{
		path: "individualstudentmerit",
		data: { title: "Individual Student Merit" },
		component: IndividualStudentMeritComponent,
	},
	{
		path: "mealaccountdeposit",
		data: { title: "Meal Account Deposit" },
		component: MealAccountDepositComponent,
	},
	{
		path: "mealtypecounts",
		data: { title: "Meal Type Counts" },
		component: MealTypeCountsComponent,
	},
	{
		path: "markroster",
		data: { title: "Mark Roster" },
		component: MarkRosterComponent,
	},
	{
		path: "convertedincidents",
		data: { title: "Converted Incidents" },
		component: ConvertedIncidentsComponent,
	},
	{
		path: "periodattendancecounts",
		data: { title: "Period Attendance Counts" },
		component: PeriodAttendanceCountsComponent,
	},
	//    {path: 'studentswithmissingalerts', data:{title:'Students with Missing Alerts'},component:StudentswithMissingAlertsComponent},
	{
		path: "visitorsbystatus",
		data: { title: "Visitors by Status" },
		component: VisitorsbyStatusComponent,
	},
	{
		path: "visitorlogsbyvisitor",
		data: { title: "Visitor Logs by Visitor" },
		component: VisitorLogsbyVisitorComponent,
	},
	//    {path: 'visitorlogsbydate', data:{title:'Visitor Logs by Date'},component:VisitorLogsbyDateComponent},
	{
		path: "visitorsphotos3cols",
		data: { title: "Visitors Photos 3 Cols" },
		component: VisitorsPhotos3ColsComponent,
	},
	{
		path: "visitorsphotos4cols",
		data: { title: "Visitors Photos 4 Cols" },
		component: VisitorsPhotos4ColsComponent,
	},
	{
		path: "detentionowed",
		data: { title: "Detention Owed" },
		component: DetentionOwedComponent,
	},
	{
		path: "detentionsummary",
		data: { title: "Detention Summary" },
		component: DetentionSummaryComponent,
	},
	{
		path: "detentionbalance",
		data: { title: "Detention Balance" },
		component: DetentionBalanceComponent,
	},
	{
		path: "visitorstoday",
		data: { title: "Visitors Today" },
		component: VisitorsTodayComponent,
	},
	{
		path: "entryalertbycontainer",
		data: { title: "Entry Alert by Container" },
		component: EntryAlertbyContainerComponent,
	},
	{
		path: "visitorlogsbypasstemplate",
		data: { title: "Visitor Logs by Pass Template" },
		component: VisitorLogsbyPassTemplateComponent,
	},
	{
		path: "visitorsbycontainer",
		data: { title: "Visitors by Container" },
		component: VisitorsbyContainerComponent,
	},
	{
		path: "visitorsummary",
		data: { title: "Visitor Summary" },
		component: VisitorSummaryComponent,
	},
	{
		path: "visitorblocklist",
		data: { title: "Visitor Block List" },
		component: VisitorBlockListComponent,
	},
	{
		path: "principalschoolstatistics",
		data: { title: "Principal School Statistics" },
		component: PrincipalSchoolStatisticsComponent,
	},
	{
		path: "dailyhotlist",
		data: { title: "Daily Hot List" },
		component: DailyHotListComponent,
	},
	{
		path: "hotlistedcardusage",
		data: { title: "Hot Listed Card Usage" },
		component: HotListedCardUsageComponent,
	},
	{
		path: "cardstatus",
		data: { title: "Card Status" },
		component: CardStatusComponent,
	},
	{
		path: "studentcaasstransactions",
		data: { title: "Student Caass Transactions" },
		component: StudentCaassTransactionsComponent,
	},
	{
		path: "cardusageduringschoolabsence",
		data: { title: "Card Usage During School Absence" },
		component: CardUsageDuringSchoolAbsenceComponent,
	},
	{
		path: "instructormissingsection",
		data: { title: "Instructor Missing Section" },
		component: InstructorMissingSectionComponent,
	},
	{
		path: "mtacardabusecounts",
		data: { title: "MTA Card Abuse Counts" },
		component: MTACardAbuseCountsComponent,
	},
	{
		path: "ridingbusduringschool",
		data: { title: "Riding Bus During School" },
		component: RidingBusDuringSchoolComponent,
	},
	{
		path: "studentclassattendancereconciliation",
		data: { title: "Student Class Attendance Reconciliation" },
		component: StudentClassAttendanceReconciliationComponent,
	},
	{
		path: "photobook",
		data: { title: "Photo Book" },
		component: PhotoBookComponent,
	},
	{
		path: "studentattendancestatus",
		data: { title: "Student Attendance Status" },
		component: StudentAttendanceStatusComponent,
	},

	//New (District Update 10/6/21)

	//Admin
	{
		path: "reportusage",
		data: { title: "Report Usage" },
		component: ReportUsageComponent,
	},

	//Baltimore OneCard District
	{
		path: "mtadailybilling",
		data: { title: "OneCard Express Daily Billing" },
		component: DistrictOneCardExpressDailyBillingComponent,
	},
	{
		path: "mtaonecardexpressqueue",
		data: { title: "OneCard Express Queue" },
		component: DistrictOneCardExpressQueueComponent,
	},
	{
		path: "mtadailyschoolshipping",
		data: { title: "OneCard Express Shipping Order" },
		component: DistrictOneCardExpressShippingOrderComponent,
	},
	{
		path: "mtastudentridetimes",
		data: { title: "MTA Student Ride Times" },
		component: DistrictMTAStudentRideTimesComponent,
	},
	{
		path: "mtadistrictstatisticschart",
		data: { title: "MTA District / School Statistics Chart" },
		component: MTADistrictStatisticsChartComponent,
	},

	//District
	{
		path: "districtdisciplineactiontiercounts",
		data: { title: "Discipline Action Level Counts" },
		component: DistrictDisciplineActionTierCountsComponent,
	},
	{
		path: "districtattendancesummary",
		data: { title: "District Attendance Summary" },
		component: DistrictAttendanceSummaryComponent,
	},
	{
		path: "districtcaassusage",
		data: { title: "District CAASS Usage" },
		component: DistrictCAASSUsageComponent,
	},

	//Doesn't work on 9.5 (Parameters don't match DB)
	{
		path: "districtratiointooutofschoolsuspensions",
		data: { title: "In/Out-of School Suspensions" },
		component: DistrictRatioIntoOutofSchoolSuspensionsComponent,
	},

	{
		path: "districtreferralsbycohort",
		data: { title: "Incidents by Cohort" },
		component: DistrictReferralsByCohortComponent,
	},
	{
		path: "districtreferralsbyethnicity",
		data: { title: "Incidents by Ethnicity" },
		component: DistrictReferralsByEthnicityComponent,
	},
	{
		path: "districtreferralsbyharassment",
		data: { title: "Incidents by Harassment" },
		component: DistrictReferralsByHarassmentComponent,
	},
	{
		path: "districtreferralsbyincidenttime",
		data: { title: "Incidents by Incident Time" },
		component: DistrictReferralsByIncidentTimeComponent,
	},
	{
		path: "districtreferralsbyinfraction",
		data: { title: "Incidents by Infraction" },
		component: DistrictReferralsByInfractionComponent,
	},
	{
		path: "districtreferralsbyinfractionlevel",
		data: { title: "Incidents by Infraction Level" },
		component: DistrictReferralsByInfractionLevelComponent,
	},
	{
		path: "districtreferralsbylocation",
		data: { title: "Incidents by Location" },
		component: DistrictReferralsByLocationComponent,
	},
	//Not used? //{path: 'DistrictReferralCountBySchoolChart', data:{title:'Incidents by School Chart'}, component: DistrictReferralCountBySchoolChartComponent},
	{
		path: "districtreferralsperyearper100students",
		data: { title: "Incidents per Year per 100 Students" },
		component: DistrictReferralsPerYearPer100StudentsComponent,
	},
	//Not used? //{path: 'DistrictInstructorWorkFlowInBox', data:{title:'Instructor Inbox Requests'}, component: DistrictInstructorWorkFlowInBoxComponent},
	{
		path: "districtmanifestationreferralsincompliance",
		data: { title: "Manifestation Incidents in Compliance" },
		component: DistrictManifestationReferralsInComplianceComponent,
	},
	{
		path: "districtmonthlyreferralaverages",
		data: { title: "Monthly Incident Averages" },
		component: DistrictMonthlyReferralAveragesComponent,
	},
	{
		path: "districtscanstationtracking",
		data: { title: "ScanStation Tracking" },
		component: DistrictScanStationTrackingComponent,
	},
	{
		path: "districtschooltotals",
		data: { title: "School Totals" },
		component: DistrictSchoolTotalsComponent,
	},
	{
		path: "districtsuspensionstepsoutofcompliance",
		data: { title: "Suspension Steps out of Compliance" },
		component: DistrictSuspensionStepsOutOfComplianceComponent,
	},
	{
		path: "districtsuspensionworkflowdetail",
		data: { title: "Suspension Workflow Detail" },
		component: DistrictSuspensionWorkflowDetailComponent,
	},
	{
		path: "districtsuspensionsnotassignedmaximumdays",
		data: { title: "Suspensions Not Assigned Maximum Days" },
		component: DistrictSuspensionsNotAssignedMaximumDaysComponent,
	},

	{
		path: "schoolmessengerattend",
		data: { title: "School Messenger Attendance" },
		component: SchoolMessengerAttendanceComponent,
	},

	{
		path: "booksforinstructor",
		data: { title: "Books Distributed by Instructor" },
		component: BooksForInstructorComponent,
	},
	{
		path: "bookinventory",
		data: { title: "Book Inventory" },
		component: BookInventoryComponent,
	},
	{
		path: "bookinventorybarcode",
		data: { title: "Book Inventory With Barcodes" },
		component: BookInventoryBarcodeComponent,
	},
	{
		path: "booksdistributed",
		data: { title: "Books Distributed" },
		component: BooksDistributedComponent,
	},
	{
		path: "booksdistributedbarcode",
		data: { title: "Books Distributed With Barcodes" },
		component: BooksDistributedBarcodeComponent,
	},
	{
		path: "picklistbyhomeroom",
		data: { title: "Course Book Pick List" },
		component: PickListByHomeRoomComponent,
	},
	{
		path: "customdetention1",
		data: { title: "Custom Detentions" },
		component: CustomDetention1Component,
	},

	{
		path: "individualstudentpbis",
		data: { title: "Individual Student PBIS" },
		component: IndividualStudentPBISComponent,
	},
	{
		path: "instructorpbis",
		data: { title: "Instructor PBIS" },
		component: InstructorPBISComponent,
	},
	{
		path: "pbishistory",
		data: { title: "PBIS History" },
		component: PBISHistoryComponent,
	},

	{
		path: "transitriderdata",
		data: { title: "Transit Rider Data" },
		component: TransitRiderDataComponent,
	},

	{
		path: "multistationvisitors",
		data: { title: "Visitors Report" },
		component: MsVisitorsComponent,
	},
	{
		path: "multistationvisitorlog",
		data: { title: "Visitor Log Report" },
		component: MsVisitorLogComponent,
	},
	{
		path: "multistationblockedlist",
		data: { title: "Blocked List" },
		component: MsBlockListComponent,
	},
	{
		path: "multistationfacilitytime",
		data: { title: "Facility Time Report" },
		component: MsFacilityTimeComponent,
	},
	{
		path: "multistationvisitortimeinfacility",
		data: { title: "Visitor Time in Facility" },
		component: MsVisitorTimeInFacilitiesComponent,
	},

	{
		path: "hallsweepschoollog",
		data: { title: "CAASS Pass Log By School" },
		component: HsSchoolLogComponent,
	},
	// {path: 'hallsweepschoolsummary', data:{title:'School Summary'}, component: HsSchoolSummaryComponent},

	{
		path: "notifystudentreg",
		data: { title: "Notify Student Registration" },
		component: NotifyStudentRegComponent,
	},
	{
		path: "notifystudentlistparents",
		data: { title: "List of Guardians for each Student" },
		component: NotifyStudentListParentsComponent,
	},
	{
		path: "notifyparentliststudents",
		data: { title: "List of Students for each Guardian" },
		component: NotifyParentListStudentsComponent,
	},

	{
		path: "badscandata",
		data: { title: "Bad Scan Data" },
		component: ScanStationBadScanDataComponent,
	},

	{
		path: "studentqrcodes",
		data: { title: "Student QR Codes" },
		component: StudentQrCodesComponent,
	},

	{
		path: "staffbarcodeexport",
		data: { title: "Staff Barcode and Photo" },
		component: StaffBarcodeExportComponent,
	},

	{
		path: "multistationusage",
		data: { title: "Visitor Station Usage" },
		component: MsUsageComponent,
	},

	{
		path: "studentdigitalidreg",
		data: { title: "Digital ID Registration" },
		component: StudentDigitalIDRegComponent,
	},

	{
		path: "timestamptimeinevent",
		data: { title: "Timestamp Off-Campus Lunch" },
		component: TimestampTimeInEventComponent,
	},

	{
		path: "studentoldphotos",
		data: { title: "Old Photos" },
		component: StudentOldPhotosComponent,
	},

	{
		path: "districtcaassusagesimple",
		data: { title: "District CAASS Usage (Simple)" },
		component: DistrictCaassUsageSimpleComponent,
	},

	{
		path: "districtcaassusagefull",
		data: { title: "District CAASS Usage (Full)" },
		component: DistrictCaassUsageFullComponent,
	},

	{
		path: "tempidcardsprinted",
		data: { title: "Temp ID Cards Printed" },
		component: TempIdCardsPrintedComponent,
	},

	{
		path: "parentportalusersbystudent",
		data: { title: "Parent Portal Users By Student" },
		component: ParentPortalUsersByStudentComponent,
	},

	{
		path: "parentportalallusers",
		data: { title: "Parent Portal All Users" },
		component: ParentPortalAllUsersComponent,
	},

	{
		path: "studentportalusers",
		data: { title: "Student Portal Users" },
		component: StudentPortalUsersComponent,
	},

	{
		path: "staffportalusers",
		data: { title: "Staff Portal Users" },
		component: StaffPortalUsersComponent,
	},

	{
		path: "studentwithdrawtransfer",
		data: { title: "Withdraws and Transfers" },
		component: StudentWithdrawTransferComponent,
	},

	{
		path: "hallsweepstudentcount",
		data: { title: "CAASS Pass Student Totals" },
		component: CaassPassStudentTotalsComponent,
	},

	{
		path: "attendancebylocation",
		data: { title: "Attendance By Location" },
		component: AttendanceByLocationComponent,
	},

	{
		path: "busrunninglate",
		data: { title: "Bus Running Late" },
		component: BusRunningLateComponent,
	},

	{
		path: "inactivecardsscanned",
		data: { title: "Inactive Cards Scanned" },
		component: InactiveCardsScannedComponent,
	},

	{
		path: "publictransitriderstatus",
		data: { title: "Public Transit Rider Status" },
		component: PublicTransitRiderStatusComponent,
	},

	{
		path: "blocklistscans",
		data: { title: "Block List Scans" },
		component: BlockListScansComponent,
	},

	{
		path: "blocklistscans",
		data: { title: "Block List Scans" },
		component: BlockListScansComponent,
	},

	{
		path: "accessscanning",
		data: { title: "Access Scanning" },
		component: AccessScanningComponent,
	},

	{
		path: "exitscanning",
		data: { title: "Exit Scanning" },
		component: ExitScanningComponent,
	},

	{
		path: "eventscanning",
		data: { title: "Event Scanning" },
		component: EventScanningComponent,
	},

	{
		path: "timestampscanningbyschool",
		data: { title: "Timestamp Scanning by School" },
		component: TimestampScanningBySchoolComponent,
	},

	{
		path: "attendancewithexcuse",
		data: { title: "Attendance With Excuse" },
		component: AttendanceWithExcuseComponent,
	},

	{
		path: "alreadyscannedin",
		data: { title: "Already Scanned In" },
		component: AlreadyScannedInComponent,
	},

	{
		path: "studentsnotriding",
		data: { title: "Students Not On Bus Today" },
		component: StudentsNotRidingComponent,
	},

	{
		path: "studentsneveronbus",
		data: { title: "Students Not Riding" },
		component: StudentsNeverOnBusComponent,
	},

	{
		path: "timescanscannedintoevent",
		data: { title: "Timestamp Scanned into Event" },
		component: TimescanScannedIntoEventComponent,
	},

	//SU Only page to import and export RPX files
	{
		path: "reportmaintenance",
		data: { title: "Import/Export (SU Only)" },
		component: ReportMaintenanceComponent,
	},
];
